import { ChevronRight, ChevronLeft } from "lucide-react"
import { Link } from "react-router-dom"

export interface BreadcrumbItem {
    label: string
    description?: string
    href?: string
}

interface BreadcrumbNavProps {
    items: BreadcrumbItem[]
}

export function BreadcrumbNav({ items }: BreadcrumbNavProps) {
    // Show at most the last two items (current and parent)
    const displayItems = items.length > 1
        ? items.slice(-2)
        : items;

    // Get the parent page URL (if we have more than 2 levels)
    const hasParentPages = items.length > 2;
    const parentPageHref = items.length > 2 ? items[items.length - 3].href : undefined;

    return (
        <div className="mb-4">
            <nav className="flex items-center text-sm">
                {/* Back indicator if we have parent pages */}
                {hasParentPages && parentPageHref && (
                    <Link
                        to={parentPageHref}
                        className="flex items-center text-sm font-medium text-neutral-500 hover:text-primary transition-colors mr-2"
                    >
                        <ChevronLeft className="h-3.5 w-3.5 mr-0.5" />
                        <span>Back</span>
                    </Link>
                )}

                {/* Display items */}
                {displayItems.map((item, index) => (
                    <div key={index} className="flex items-center">
                        {index > 0 && (
                            <ChevronRight className="mx-2 h-3.5 w-3.5 text-neutral-400 shrink-0" />
                        )}

                        {item.href && index < displayItems.length - 1 ? (
                            <Link
                                to={item.href}
                                className="text-sm font-medium text-neutral-500 hover:text-primary transition-colors"
                            >
                                {item.label}
                            </Link>
                        ) : (
                            <span className={`text-sm font-medium ${index === displayItems.length - 1 ? "bg-neutral-100 dark:bg-neutral-800 px-3 py-1.5 rounded-full" : ""}`}>
                                {item.label}
                            </span>
                        )}
                    </div>
                ))}
            </nav>

            {/* Show description of current (last) item */}
            {items[items.length - 1]?.description && (
                <p className="text-xs text-neutral-500 mt-1 line-clamp-1">
                    {items[items.length - 1].description}
                </p>
            )}
        </div>
    )
} 